export class Plural {
  /**
   * Plural forms for russian words with count
   * @param count quantity for word
   * @param words
   * - Array of words. Example: ['депутат', 'депутата', 'депутатов'], ['коментарий', 'коментария', 'комментариев']
   * - строка форм, разделенных '|'. Example: 'депутат|депутата|депутатов', 'коментарий|коментария|комментариев'
   * @return count + plural form for word
   */
  static with(count: number, words: string[] | string): string {
    return `${count} ${this.of(count, words)}`
  }

  /**
   * Plural forms for russian words with count
   * @param count quantity for word
   * @param words
   * - Array of words. Example: ['депутат', 'депутата', 'депутатов'], ['коментарий', 'коментария', 'комментариев']
   * - строка форм, разделенных '|'. Example: 'депутат|депутата|депутатов', 'коментарий|коментария|комментариев'
   * @return count + plural form for word
   */
  static of(count: number, words: string[] | string): string {
    const forms = typeof words === 'string' ? words.split('|') : words
    const cases = [2, 0, 1, 1, 1, 2]

    return forms[count % 100 > 4 && count % 100 < 20 ? 2 : cases[Math.min(count % 10, 5)]]
  }
}